import { Component } from '@angular/core';

@Component({
    selector: 'app-dashboard-content',
    templateUrl: './dashboard-content.component.html',
    styleUrls: ['./dashboard-content.component.scss'],
    standalone: false
})
export class DashboardContentComponent {
}
